import * as types from '../mutation-types/pages'

// set this true to namespace all getters, mutations, actions etc.
const namespaced =  true
export const namespace = 'pages'

// state
const state = {
  savedLastRoute: null,
  savedLastRouteData: {},
  showGlobalTimer: true,
}

// mutations
const mutations = {
  [types.SET_LAST_ROUTE](state, page) {
    state.postLoginPage = page
  },
  [types.SET_LAST_ROUTE_DATA](state, page) {
    state.postLoginSection = page
  },
  [types.HIDE_GLOBAL_TIMER](state) {
    state.showGlobalTimer = false
  },
  [types.SHOW_GLOBAL_TIMER](state, hide) {
    state.showGlobalTimer = true
  }
}

const actions = {
  savePageBeforeLeave({commit}, {page, options}) {
    commit(types.SET_LAST_ROUTE, _.isString(page) ? page : page.name)
    commit(types.SET_LAST_ROUTE_DATA, options)
  },
  allowShowingGlobalTimer({commit}) {
    commit(types.SHOW_GLOBAL_TIMER)
  },
  hideGlobalTimer({commit}) {
    commit(types.HIDE_GLOBAL_TIMER)
  }
}

// getters
const getters = {
  savedLastRoute: state => ({name: state.savedLastRoute, options: state.savedLastRouteData}),
  showingGlobalTimer: state => state.showGlobalTimer,
}

const pages = { namespaced, namespace, state, mutations, actions, getters }
export default pages
